// src/pages/LinkTree.js
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AdminContext } from "../context/AdminContext";
import { useTables } from "../hooks/useTables";

// 👇 NEW: Import the Lucide icons
import { Users, UtensilsCrossed, Dices, Swords, MessageCircle, MapPin } from "lucide-react";

import Config from "../Config.json";
import styles from "../assets/css/LinkTree.module.css";
import profilepic from "../assets/images/pfp.png";
import ICON from "../assets/icons/favicon.ico";

const TITLE = Config.SITE_TITLE + " - Link Tree";
const DESC = "Board Game Café do Cariri";
const CANONICAL = Config.SITE_DOMAIN + "/";

function LinkTree() {
  const { isAdmin } = useContext(AdminContext);
  const { status, loading } = useTables();

  const renderStatus = () => {
    if (loading) {
        return (
            <div className={styles.statusContainer}>
                <span style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.7)' }}>
                    Verificando disponibilidade...
                </span>
            </div>
        );
    }

    if (!status) return null;

    if (status === 'Closed') {
        return (
            <div className={styles.statusContainer}>
                <div className={`${styles.statusMain} ${styles.statusClosed}`}>
                    <span className={`${styles.statusIndicator} ${styles.indicatorClosed}`}></span>
                    Fechado Agora
                </div>
            </div>
        );
    }

    return (
        <div className={styles.statusContainer}>
            <div className={`${styles.statusMain} ${styles.statusOpen}`}>
                <span className={`${styles.statusIndicator} ${styles.indicatorOpen}`}></span>
                Aberto
            </div>
            {status === 'Available' ? (
                <span className={`${styles.statusBadge} ${styles.badgeAvailable}`}>
                    Mesas Disponíveis
                </span>
            ) : (
                <span className={`${styles.statusBadge} ${styles.badgeFull}`}>
                    Lotação Máxima
                </span>
            )}
        </div>
    );
  };

  return (
    <main className={styles.container}>
      <title>{TITLE}</title>
      <link rel="icon" href={ICON} />
      <link rel="canonical" href={CANONICAL} />
      <meta name="description" content={DESC} />
      
      <div className={styles.header}>
        <figure className={styles.avatar}>
          <img src={profilepic} alt="Deli da Persy" />
        </figure>
        <h1 className={styles.title}>Deli da Persy</h1>
        <h2 className={styles.subtitle}>☕ Board Game Café</h2>
        {isAdmin && renderStatus()}
      </div>

      {isAdmin && (
        <Link to="/sobre">
          <button className={styles.button}>
            Quem somos ? <Users size={18} className={styles.buttonIcon} />
          </button>
        </Link>
      )}
      
      <Link to="/cardapio">
        <button className={styles.button}>
            Cardápio <UtensilsCrossed size={18} className={styles.buttonIcon} />
        </button>
      </Link>
      
      <Link to="/biblioteca">
        <button className={styles.button}>
            Biblioteca de Jogos <Dices size={18} className={styles.buttonIcon} />
        </button>
      </Link>
      
      {isAdmin && (
        <Link to="/sobre/rpg">
          <button className={styles.button}>
              RPG <Swords size={18} className={styles.buttonIcon} />
          </button>
        </Link>
      )}
      
      <a href="https://wa.me/558821577839">
        <button className={styles.button}>
            Contato <MessageCircle size={18} className={styles.buttonIcon} />
        </button>
      </a>
      
      <Link to="/local">
        <button className={styles.button}>
            Localização <MapPin size={18} className={styles.buttonIcon} />
        </button>
      </Link>
    </main>
  );
}

export default LinkTree;